import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full pt-16 pb-8 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-159">
          {/* Logo & Description */}
          <div className="md:col-span-1" data-id="element-160">
            <a href="#" className="flex items-center gap-1 mb-4" data-id="element-161">
              <span className="text-2xl font-bold tracking-tight" style={{
              color: 'var(--text-primary)'
            }} data-id="element-162">
                IT Cluster
              </span>
              <span className="w-2 h-2 rounded-full" style={{
              backgroundColor: 'var(--accent)'
            }} data-id="element-163" />
            </a>
            <p className="text-sm leading-relaxed" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-164">
              {t('footer.desc')}
            </p>
          </div>

          {/* Links Columns */}
          <div data-id="element-165">
            <h4 className="font-bold mb-4" style={{
            color: 'var(--text-primary)'
          }} data-id="element-166">
              {t('footer.c1')}
            </h4>
            <ul className="space-y-3" data-id="element-167">
              <li data-id="element-168">
                <a href="#about" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-169">
                  {t('nav.about')}
                </a>
              </li>
              <li data-id="element-170">
                <a href="#members" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-171">
                  {t('nav.members')}
                </a>
              </li>
              <li data-id="element-172">
                <a href="#partners" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-173">
                  {t('nav.projects')}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-174">
            <h4 className="font-bold mb-4" style={{
            color: 'var(--text-primary)'
          }} data-id="element-175">
              {t('footer.c2')}
            </h4>
            <ul className="space-y-3" data-id="element-176">
              <li data-id="element-177">
                <a href="#projects" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-178">
                  {t('nav.projects')}
                </a>
              </li>
              <li data-id="element-179">
                <a href="#events" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-180">
                  {t('nav.events')}
                </a>
              </li>
              <li data-id="element-181">
                <a href="#news" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-182">
                  {t('nav.news')}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-183">
            <h4 className="font-bold mb-4" style={{
            color: 'var(--text-primary)'
          }} data-id="element-184">
              {t('footer.c3')}
            </h4>
            <ul className="space-y-3" data-id="element-185">
              <li data-id="element-186">
                <a href="#join" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-187">
                  {t('nav.join')}
                </a>
              </li>
              <li data-id="element-188">
                <a href="#contacts" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-189">
                  {t('nav.contacts')}
                </a>
              </li>
              <li data-id="element-190">
                <a href="#faq" className="text-sm hover:underline" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-191">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4" style={{
        borderColor: 'var(--border)'
      }} data-id="element-192">
          <p className="text-sm" style={{
          color: 'var(--text-muted)'
        }} data-id="element-193">
            © 2026 IT Cluster. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-4" data-id="element-194">
            <a href="#" className="w-8 h-8 rounded-full flex items-center justify-center transition-colors hover:bg-[var(--bg-tertiary)]" style={{
            color: 'var(--text-muted)'
          }} data-id="element-195">
              IN
            </a>
            <a href="#" className="w-8 h-8 rounded-full flex items-center justify-center transition-colors hover:bg-[var(--bg-tertiary)]" style={{
            color: 'var(--text-muted)'
          }} data-id="element-196">
              FB
            </a>
            <a href="#" className="w-8 h-8 rounded-full flex items-center justify-center transition-colors hover:bg-[var(--bg-tertiary)]" style={{
            color: 'var(--text-muted)'
          }} data-id="element-197">
              TW
            </a>
          </div>
        </div>
      </div>
    </footer>;
}